/*
 * @Description: Description
 * @Author: Dai Guo
 * @Date: 2022-01-25 10:44:54
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-03-11 09:29:10
 */
import LengthZ from '../lengthTypes/lengthZ';
import { LengthLocation, LengthType } from '../utils/enum';
import { AISLE_WIDTH, FRAMEDEPTH } from '../utils/kitchenConfig';
class RenderSubscribe {
    constructor(json, Scene) {
        this.eventList = {}; // 监听事件对象
        this.prevStatus = ''; // 前一次的状态 为了不一直刷新 改变的时候才刷新
        this.currentStatus = ''; // 当前状态
        this.l2SideLength = 0; // l2边的长度 判断相机位置的时候需要用到
        const bottomLength2 = new LengthZ(json, Scene, LengthLocation.Bottom, LengthType.Length2);
        if (json.bottom.type === 'H') {
            this.l2SideLength = FRAMEDEPTH.BOTTOM * 2 + AISLE_WIDTH;
        }
        else {
            this.l2SideLength = bottomLength2.getSideLength();
        }
    }
    /**
     * 添加监听事件
     * @param key 监听事件的key
     * @param fn 不同事件需要做的事情
     * @returns
     */
    subscribe(key, fn) {
        if (typeof this.eventList[key] !== 'undefined')
            return;
        this.eventList[key] = fn;
    }
    /**
     * 执行
     * @param key 分发的事件key
     * @param immediatelyUpdate 是否立即执行一次
     */
    release(key, immediatelyUpdate) {
        this.prevStatus = this.currentStatus;
        this.currentStatus = key;
        const fn = this.eventList[key];
        if (typeof fn !== 'undefined' && (this.prevStatus === this.currentStatus || immediatelyUpdate)) {
            fn();
        }
    }
    /**
     * 分发
     * @param cameraPosition 相机信息
     * @param distance 相机的初始化radius
     * @param immediatelyUpdate 是否立即执行
     */
    dispatch(cameraPosition, distance, isUpdate) {
        const { position, radius } = cameraPosition;
        const percent = (2.1333 * radius) / distance;
        if (position.z < -percent) {
            this.release('hideL1', isUpdate);
        }
        else if (position.z < this.l2SideLength + percent) {
            this.release('showAll', isUpdate);
        }
        else {
            this.release('hideL3', isUpdate);
        }
    }
}
export default RenderSubscribe;
